// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,json_types=true"
// @generated from file abacus/v2/reports.proto (package abacus.v2, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ChartRequest, ChartRequestJson, DashboardFilter, DashboardFilterJson, Interval, IntervalJson, StreamPdfFileRequest, StreamPdfFileRequestJson, StreamZipFileRequest, StreamZipFileRequestJson } from "./abacus_pb";
import { file_abacus_v2_abacus } from "./abacus_pb";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import type { PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import type { Creator, CreatorJson } from "../../common/v1/types_pb";
import { file_common_v1_types } from "../../common/v1/types_pb";
import type { FieldMask, FieldMaskJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file abacus/v2/reports.proto.
 */
export const file_abacus_v2_reports: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_abacus_v2_abacus, file_common_v1_annotations, file_common_v1_pagination, file_common_v1_types, file_google_protobuf_field_mask, file_google_protobuf_timestamp],
	);

/**
 * @generated from message abacus.v2.ReportData
 */
export type ReportData = Message<"abacus.v2.ReportData"> & {
	/**
	 * @generated from field: string file_name = 1;
	 */
	fileName: string;

	/**
	 * @generated from oneof abacus.v2.ReportData.request
	 */
	request:
		| {
				/**
				 * @generated from field: abacus.v2.StreamZipFileRequest stream_zip_file_request = 2;
				 */
				value: StreamZipFileRequest;
				case: "streamZipFileRequest";
		  }
		| {
				/**
				 * @generated from field: abacus.v2.StreamPdfFileRequest stream_pdf_file_request = 3;
				 */
				value: StreamPdfFileRequest;
				case: "streamPdfFileRequest";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message abacus.v2.ReportData
 */
export type ReportDataJson = {
	/**
	 * @generated from field: string file_name = 1;
	 */
	fileName?: string;

	/**
	 * @generated from field: abacus.v2.StreamZipFileRequest stream_zip_file_request = 2;
	 */
	streamZipFileRequest?: StreamZipFileRequestJson;

	/**
	 * @generated from field: abacus.v2.StreamPdfFileRequest stream_pdf_file_request = 3;
	 */
	streamPdfFileRequest?: StreamPdfFileRequestJson;
};

/**
 * Describes the message abacus.v2.ReportData.
 * Use `create(ReportDataSchema)` to create a new message.
 */
export const ReportDataSchema: GenMessage<ReportData, { jsonType: ReportDataJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 0);

/**
 * @generated from message abacus.v2.Report
 */
export type Report = Message<"abacus.v2.Report"> & {
	/**
	 * @generated from field: string name = 1;
	 */
	name: string;

	/**
	 * @generated from field: string description = 9;
	 */
	description: string;

	/**
	 * @generated from field: string org_id = 6;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 7;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string suite_id = 8;
	 */
	suiteId: string;

	/**
	 * @generated from field: common.v1.Creator creator = 2;
	 */
	creator?: Creator | undefined;

	/**
	 * @generated from field: repeated string recipients = 3;
	 */
	recipients: string[];

	/**
	 * @generated from field: string email_template_id = 4;
	 */
	emailTemplateId: string;

	/**
	 * @generated from field: repeated abacus.v2.ReportData report_data = 5;
	 */
	reportData: ReportData[];
};

/**
 * @generated from message abacus.v2.Report
 */
export type ReportJson = {
	/**
	 * @generated from field: string name = 1;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 9;
	 */
	description?: string;

	/**
	 * @generated from field: string org_id = 6;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 7;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string suite_id = 8;
	 */
	suiteId?: string;

	/**
	 * @generated from field: common.v1.Creator creator = 2;
	 */
	creator?: CreatorJson;

	/**
	 * @generated from field: repeated string recipients = 3;
	 */
	recipients?: string[];

	/**
	 * @generated from field: string email_template_id = 4;
	 */
	emailTemplateId?: string;

	/**
	 * @generated from field: repeated abacus.v2.ReportData report_data = 5;
	 */
	reportData?: ReportDataJson[];
};

/**
 * Describes the message abacus.v2.Report.
 * Use `create(ReportSchema)` to create a new message.
 */
export const ReportSchema: GenMessage<Report, { jsonType: ReportJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 1);

/**
 * @generated from message abacus.v2.CalendarRange
 */
export type CalendarRange = Message<"abacus.v2.CalendarRange"> & {
	/**
	 * @generated from field: int32 start = 1;
	 */
	start: number;

	/**
	 * @generated from field: int32 end = 2;
	 */
	end: number;

	/**
	 * @generated from field: int32 step = 3;
	 */
	step: number;
};

/**
 * @generated from message abacus.v2.CalendarRange
 */
export type CalendarRangeJson = {
	/**
	 * @generated from field: int32 start = 1;
	 */
	start?: number;

	/**
	 * @generated from field: int32 end = 2;
	 */
	end?: number;

	/**
	 * @generated from field: int32 step = 3;
	 */
	step?: number;
};

/**
 * Describes the message abacus.v2.CalendarRange.
 * Use `create(CalendarRangeSchema)` to create a new message.
 */
export const CalendarRangeSchema: GenMessage<CalendarRange, { jsonType: CalendarRangeJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 2);

/**
 * @generated from message abacus.v2.ScheduleCalendar
 */
export type ScheduleCalendar = Message<"abacus.v2.ScheduleCalendar"> & {
	/**
	 * @generated from field: repeated abacus.v2.CalendarRange second = 1;
	 */
	second: CalendarRange[];

	/**
	 * @generated from field: repeated abacus.v2.CalendarRange minute = 2;
	 */
	minute: CalendarRange[];

	/**
	 * @generated from field: repeated abacus.v2.CalendarRange hour = 3;
	 */
	hour: CalendarRange[];

	/**
	 * @generated from field: repeated abacus.v2.CalendarRange day_of_week = 4;
	 */
	dayOfWeek: CalendarRange[];

	/**
	 * @generated from field: repeated abacus.v2.CalendarRange day_of_month = 5;
	 */
	dayOfMonth: CalendarRange[];

	/**
	 * @generated from field: repeated abacus.v2.CalendarRange month = 6;
	 */
	month: CalendarRange[];

	/**
	 * @generated from field: repeated abacus.v2.CalendarRange year = 7;
	 */
	year: CalendarRange[];
};

/**
 * @generated from message abacus.v2.ScheduleCalendar
 */
export type ScheduleCalendarJson = {
	/**
	 * @generated from field: repeated abacus.v2.CalendarRange second = 1;
	 */
	second?: CalendarRangeJson[];

	/**
	 * @generated from field: repeated abacus.v2.CalendarRange minute = 2;
	 */
	minute?: CalendarRangeJson[];

	/**
	 * @generated from field: repeated abacus.v2.CalendarRange hour = 3;
	 */
	hour?: CalendarRangeJson[];

	/**
	 * @generated from field: repeated abacus.v2.CalendarRange day_of_week = 4;
	 */
	dayOfWeek?: CalendarRangeJson[];

	/**
	 * @generated from field: repeated abacus.v2.CalendarRange day_of_month = 5;
	 */
	dayOfMonth?: CalendarRangeJson[];

	/**
	 * @generated from field: repeated abacus.v2.CalendarRange month = 6;
	 */
	month?: CalendarRangeJson[];

	/**
	 * @generated from field: repeated abacus.v2.CalendarRange year = 7;
	 */
	year?: CalendarRangeJson[];
};

/**
 * Describes the message abacus.v2.ScheduleCalendar.
 * Use `create(ScheduleCalendarSchema)` to create a new message.
 */
export const ScheduleCalendarSchema: GenMessage<ScheduleCalendar, { jsonType: ScheduleCalendarJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 3);

/**
 * @generated from message abacus.v2.ScheduleInterval
 */
export type ScheduleInterval = Message<"abacus.v2.ScheduleInterval"> & {
	/**
	 * @generated from field: string every = 1;
	 */
	every: string;

	/**
	 * @generated from field: string offset = 2;
	 */
	offset: string;
};

/**
 * @generated from message abacus.v2.ScheduleInterval
 */
export type ScheduleIntervalJson = {
	/**
	 * @generated from field: string every = 1;
	 */
	every?: string;

	/**
	 * @generated from field: string offset = 2;
	 */
	offset?: string;
};

/**
 * Describes the message abacus.v2.ScheduleInterval.
 * Use `create(ScheduleIntervalSchema)` to create a new message.
 */
export const ScheduleIntervalSchema: GenMessage<ScheduleInterval, { jsonType: ScheduleIntervalJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 4);

/**
 * @generated from message abacus.v2.ScheduleRecurrence
 */
export type ScheduleRecurrence = Message<"abacus.v2.ScheduleRecurrence"> & {
	/**
	 * @generated from field: abacus.v2.ScheduledReportFrequency frequency = 1;
	 */
	frequency: ScheduledReportFrequency;

	/**
	 * @generated from field: repeated abacus.v2.ScheduleCalendar calendar = 2;
	 */
	calendar: ScheduleCalendar[];

	/**
	 * @generated from field: repeated abacus.v2.ScheduleInterval interval = 3;
	 */
	interval: ScheduleInterval[];

	/**
	 * @generated from field: google.protobuf.Timestamp start_time = 4;
	 */
	startTime?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp end_time = 5;
	 */
	endTime?: Timestamp | undefined;

	/**
	 * @generated from field: string timezone = 6;
	 */
	timezone: string;
};

/**
 * @generated from message abacus.v2.ScheduleRecurrence
 */
export type ScheduleRecurrenceJson = {
	/**
	 * @generated from field: abacus.v2.ScheduledReportFrequency frequency = 1;
	 */
	frequency?: ScheduledReportFrequencyJson;

	/**
	 * @generated from field: repeated abacus.v2.ScheduleCalendar calendar = 2;
	 */
	calendar?: ScheduleCalendarJson[];

	/**
	 * @generated from field: repeated abacus.v2.ScheduleInterval interval = 3;
	 */
	interval?: ScheduleIntervalJson[];

	/**
	 * @generated from field: google.protobuf.Timestamp start_time = 4;
	 */
	startTime?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp end_time = 5;
	 */
	endTime?: TimestampJson;

	/**
	 * @generated from field: string timezone = 6;
	 */
	timezone?: string;
};

/**
 * Describes the message abacus.v2.ScheduleRecurrence.
 * Use `create(ScheduleRecurrenceSchema)` to create a new message.
 */
export const ScheduleRecurrenceSchema: GenMessage<ScheduleRecurrence, { jsonType: ScheduleRecurrenceJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 5);

/**
 * @generated from message abacus.v2.ScheduledReport
 */
export type ScheduledReport = Message<"abacus.v2.ScheduledReport"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string suite_id = 4;
	 */
	suiteId: string;

	/**
	 * @generated from field: string dashboard_id = 16;
	 */
	dashboardId: string;

	/**
	 * @generated from field: string name = 5;
	 */
	name: string;

	/**
	 * @generated from field: string description = 14;
	 */
	description: string;

	/**
	 * @generated from field: abacus.v2.ScheduledReportType type = 6;
	 */
	type: ScheduledReportType;

	/**
	 * @generated from field: abacus.v2.Report report = 7;
	 */
	report?: Report | undefined;

	/**
	 * @generated from field: abacus.v2.Interval report_interval = 15;
	 */
	reportInterval: Interval;

	/**
	 * @generated from field: abacus.v2.ScheduleRecurrence recurrence = 8;
	 */
	recurrence?: ScheduleRecurrence | undefined;

	/**
	 * @generated from field: bool is_paused = 9;
	 */
	isPaused: boolean;

	/**
	 * @generated from field: google.protobuf.Timestamp next_delivery = 10;
	 */
	nextDelivery?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp last_delivery = 11;
	 */
	lastDelivery?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 12;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 13;
	 */
	updatedAt?: Timestamp | undefined;
};

/**
 * @generated from message abacus.v2.ScheduledReport
 */
export type ScheduledReportJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string suite_id = 4;
	 */
	suiteId?: string;

	/**
	 * @generated from field: string dashboard_id = 16;
	 */
	dashboardId?: string;

	/**
	 * @generated from field: string name = 5;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 14;
	 */
	description?: string;

	/**
	 * @generated from field: abacus.v2.ScheduledReportType type = 6;
	 */
	type?: ScheduledReportTypeJson;

	/**
	 * @generated from field: abacus.v2.Report report = 7;
	 */
	report?: ReportJson;

	/**
	 * @generated from field: abacus.v2.Interval report_interval = 15;
	 */
	reportInterval?: IntervalJson;

	/**
	 * @generated from field: abacus.v2.ScheduleRecurrence recurrence = 8;
	 */
	recurrence?: ScheduleRecurrenceJson;

	/**
	 * @generated from field: bool is_paused = 9;
	 */
	isPaused?: boolean;

	/**
	 * @generated from field: google.protobuf.Timestamp next_delivery = 10;
	 */
	nextDelivery?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp last_delivery = 11;
	 */
	lastDelivery?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 12;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 13;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message abacus.v2.ScheduledReport.
 * Use `create(ScheduledReportSchema)` to create a new message.
 */
export const ScheduledReportSchema: GenMessage<ScheduledReport, { jsonType: ScheduledReportJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 6);

/**
 * @generated from message abacus.v2.ExecuteReportRequest
 */
export type ExecuteReportRequest = Message<"abacus.v2.ExecuteReportRequest"> & {
	/**
	 * @generated from field: abacus.v2.Report report = 1;
	 */
	report?: Report | undefined;
};

/**
 * @generated from message abacus.v2.ExecuteReportRequest
 */
export type ExecuteReportRequestJson = {
	/**
	 * @generated from field: abacus.v2.Report report = 1;
	 */
	report?: ReportJson;
};

/**
 * Describes the message abacus.v2.ExecuteReportRequest.
 * Use `create(ExecuteReportRequestSchema)` to create a new message.
 */
export const ExecuteReportRequestSchema: GenMessage<ExecuteReportRequest, { jsonType: ExecuteReportRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 7);

/**
 * @generated from message abacus.v2.ExecuteReportResponse
 */
export type ExecuteReportResponse = Message<"abacus.v2.ExecuteReportResponse"> & {};

/**
 * @generated from message abacus.v2.ExecuteReportResponse
 */
export type ExecuteReportResponseJson = {};

/**
 * Describes the message abacus.v2.ExecuteReportResponse.
 * Use `create(ExecuteReportResponseSchema)` to create a new message.
 */
export const ExecuteReportResponseSchema: GenMessage<ExecuteReportResponse, { jsonType: ExecuteReportResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 8);

/**
 * @generated from message abacus.v2.CreateScheduledReportRequest
 */
export type CreateScheduledReportRequest = Message<"abacus.v2.CreateScheduledReportRequest"> & {
	/**
	 * @generated from field: abacus.v2.ScheduledReport scheduled_report = 1;
	 */
	scheduledReport?: ScheduledReport | undefined;
};

/**
 * @generated from message abacus.v2.CreateScheduledReportRequest
 */
export type CreateScheduledReportRequestJson = {
	/**
	 * @generated from field: abacus.v2.ScheduledReport scheduled_report = 1;
	 */
	scheduledReport?: ScheduledReportJson;
};

/**
 * Describes the message abacus.v2.CreateScheduledReportRequest.
 * Use `create(CreateScheduledReportRequestSchema)` to create a new message.
 */
export const CreateScheduledReportRequestSchema: GenMessage<CreateScheduledReportRequest, { jsonType: CreateScheduledReportRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 9);

/**
 * @generated from message abacus.v2.CreateScheduledReportResponse
 */
export type CreateScheduledReportResponse = Message<"abacus.v2.CreateScheduledReportResponse"> & {
	/**
	 * @generated from field: abacus.v2.ScheduledReport scheduled_report = 1;
	 */
	scheduledReport?: ScheduledReport | undefined;
};

/**
 * @generated from message abacus.v2.CreateScheduledReportResponse
 */
export type CreateScheduledReportResponseJson = {
	/**
	 * @generated from field: abacus.v2.ScheduledReport scheduled_report = 1;
	 */
	scheduledReport?: ScheduledReportJson;
};

/**
 * Describes the message abacus.v2.CreateScheduledReportResponse.
 * Use `create(CreateScheduledReportResponseSchema)` to create a new message.
 */
export const CreateScheduledReportResponseSchema: GenMessage<CreateScheduledReportResponse, { jsonType: CreateScheduledReportResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 10);

/**
 * @generated from message abacus.v2.UpdateScheduledReportRequest
 */
export type UpdateScheduledReportRequest = Message<"abacus.v2.UpdateScheduledReportRequest"> & {
	/**
	 * @generated from field: abacus.v2.ScheduledReport scheduled_report = 1;
	 */
	scheduledReport?: ScheduledReport | undefined;
};

/**
 * @generated from message abacus.v2.UpdateScheduledReportRequest
 */
export type UpdateScheduledReportRequestJson = {
	/**
	 * @generated from field: abacus.v2.ScheduledReport scheduled_report = 1;
	 */
	scheduledReport?: ScheduledReportJson;
};

/**
 * Describes the message abacus.v2.UpdateScheduledReportRequest.
 * Use `create(UpdateScheduledReportRequestSchema)` to create a new message.
 */
export const UpdateScheduledReportRequestSchema: GenMessage<UpdateScheduledReportRequest, { jsonType: UpdateScheduledReportRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 11);

/**
 * @generated from message abacus.v2.UpdateScheduledReportResponse
 */
export type UpdateScheduledReportResponse = Message<"abacus.v2.UpdateScheduledReportResponse"> & {
	/**
	 * @generated from field: abacus.v2.ScheduledReport scheduled_report = 1;
	 */
	scheduledReport?: ScheduledReport | undefined;
};

/**
 * @generated from message abacus.v2.UpdateScheduledReportResponse
 */
export type UpdateScheduledReportResponseJson = {
	/**
	 * @generated from field: abacus.v2.ScheduledReport scheduled_report = 1;
	 */
	scheduledReport?: ScheduledReportJson;
};

/**
 * Describes the message abacus.v2.UpdateScheduledReportResponse.
 * Use `create(UpdateScheduledReportResponseSchema)` to create a new message.
 */
export const UpdateScheduledReportResponseSchema: GenMessage<UpdateScheduledReportResponse, { jsonType: UpdateScheduledReportResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 12);

/**
 * @generated from message abacus.v2.GetScheduledReportRequest
 */
export type GetScheduledReportRequest = Message<"abacus.v2.GetScheduledReportRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message abacus.v2.GetScheduledReportRequest
 */
export type GetScheduledReportRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message abacus.v2.GetScheduledReportRequest.
 * Use `create(GetScheduledReportRequestSchema)` to create a new message.
 */
export const GetScheduledReportRequestSchema: GenMessage<GetScheduledReportRequest, { jsonType: GetScheduledReportRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 13);

/**
 * @generated from message abacus.v2.GetScheduledReportResponse
 */
export type GetScheduledReportResponse = Message<"abacus.v2.GetScheduledReportResponse"> & {
	/**
	 * @generated from field: abacus.v2.ScheduledReport scheduled_report = 1;
	 */
	scheduledReport?: ScheduledReport | undefined;
};

/**
 * @generated from message abacus.v2.GetScheduledReportResponse
 */
export type GetScheduledReportResponseJson = {
	/**
	 * @generated from field: abacus.v2.ScheduledReport scheduled_report = 1;
	 */
	scheduledReport?: ScheduledReportJson;
};

/**
 * Describes the message abacus.v2.GetScheduledReportResponse.
 * Use `create(GetScheduledReportResponseSchema)` to create a new message.
 */
export const GetScheduledReportResponseSchema: GenMessage<GetScheduledReportResponse, { jsonType: GetScheduledReportResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 14);

/**
 * @generated from message abacus.v2.ListScheduledReportsRequest
 */
export type ListScheduledReportsRequest = Message<"abacus.v2.ListScheduledReportsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string suite_id = 3;
	 */
	suiteId: string;

	/**
	 * @generated from field: optional string dashboard_id = 12;
	 */
	dashboardId?: string | undefined;

	/**
	 * @generated from field: string name = 4;
	 */
	name: string;

	/**
	 * @generated from field: string user_id = 5;
	 */
	userId: string;

	/**
	 * @generated from field: string creator_email = 6;
	 */
	creatorEmail: string;

	/**
	 * @generated from field: repeated string recipients = 10;
	 */
	recipients: string[];

	/**
	 * @generated from field: abacus.v2.ScheduledReportType type = 7;
	 */
	type: ScheduledReportType;

	/**
	 * @generated from field: abacus.v2.ScheduledReportFrequency frequency = 8;
	 */
	frequency: ScheduledReportFrequency;

	/**
	 * @generated from field: abacus.v2.ScheduledReportState state = 11;
	 */
	state: ScheduledReportState;

	/**
	 * @generated from field: optional common.v1.PaginationArguments pagination = 9;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * @generated from message abacus.v2.ListScheduledReportsRequest
 */
export type ListScheduledReportsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string suite_id = 3;
	 */
	suiteId?: string;

	/**
	 * @generated from field: optional string dashboard_id = 12;
	 */
	dashboardId?: string;

	/**
	 * @generated from field: string name = 4;
	 */
	name?: string;

	/**
	 * @generated from field: string user_id = 5;
	 */
	userId?: string;

	/**
	 * @generated from field: string creator_email = 6;
	 */
	creatorEmail?: string;

	/**
	 * @generated from field: repeated string recipients = 10;
	 */
	recipients?: string[];

	/**
	 * @generated from field: abacus.v2.ScheduledReportType type = 7;
	 */
	type?: ScheduledReportTypeJson;

	/**
	 * @generated from field: abacus.v2.ScheduledReportFrequency frequency = 8;
	 */
	frequency?: ScheduledReportFrequencyJson;

	/**
	 * @generated from field: abacus.v2.ScheduledReportState state = 11;
	 */
	state?: ScheduledReportStateJson;

	/**
	 * @generated from field: optional common.v1.PaginationArguments pagination = 9;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message abacus.v2.ListScheduledReportsRequest.
 * Use `create(ListScheduledReportsRequestSchema)` to create a new message.
 */
export const ListScheduledReportsRequestSchema: GenMessage<ListScheduledReportsRequest, { jsonType: ListScheduledReportsRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 15);

/**
 * @generated from message abacus.v2.ListScheduledReportsResponse
 */
export type ListScheduledReportsResponse = Message<"abacus.v2.ListScheduledReportsResponse"> & {
	/**
	 * @generated from field: repeated abacus.v2.ScheduledReport scheduled_reports = 1;
	 */
	scheduledReports: ScheduledReport[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message abacus.v2.ListScheduledReportsResponse
 */
export type ListScheduledReportsResponseJson = {
	/**
	 * @generated from field: repeated abacus.v2.ScheduledReport scheduled_reports = 1;
	 */
	scheduledReports?: ScheduledReportJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message abacus.v2.ListScheduledReportsResponse.
 * Use `create(ListScheduledReportsResponseSchema)` to create a new message.
 */
export const ListScheduledReportsResponseSchema: GenMessage<ListScheduledReportsResponse, { jsonType: ListScheduledReportsResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 16);

/**
 * @generated from message abacus.v2.ToggleScheduledReportRequest
 */
export type ToggleScheduledReportRequest = Message<"abacus.v2.ToggleScheduledReportRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: bool pause = 2;
	 */
	pause: boolean;
};

/**
 * @generated from message abacus.v2.ToggleScheduledReportRequest
 */
export type ToggleScheduledReportRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: bool pause = 2;
	 */
	pause?: boolean;
};

/**
 * Describes the message abacus.v2.ToggleScheduledReportRequest.
 * Use `create(ToggleScheduledReportRequestSchema)` to create a new message.
 */
export const ToggleScheduledReportRequestSchema: GenMessage<ToggleScheduledReportRequest, { jsonType: ToggleScheduledReportRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 17);

/**
 * @generated from message abacus.v2.ToggleScheduledReportResponse
 */
export type ToggleScheduledReportResponse = Message<"abacus.v2.ToggleScheduledReportResponse"> & {
	/**
	 * @generated from field: abacus.v2.ScheduledReport scheduled_report = 1;
	 */
	scheduledReport?: ScheduledReport | undefined;
};

/**
 * @generated from message abacus.v2.ToggleScheduledReportResponse
 */
export type ToggleScheduledReportResponseJson = {
	/**
	 * @generated from field: abacus.v2.ScheduledReport scheduled_report = 1;
	 */
	scheduledReport?: ScheduledReportJson;
};

/**
 * Describes the message abacus.v2.ToggleScheduledReportResponse.
 * Use `create(ToggleScheduledReportResponseSchema)` to create a new message.
 */
export const ToggleScheduledReportResponseSchema: GenMessage<ToggleScheduledReportResponse, { jsonType: ToggleScheduledReportResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 18);

/**
 * @generated from message abacus.v2.TriggerScheduledReportRequest
 */
export type TriggerScheduledReportRequest = Message<"abacus.v2.TriggerScheduledReportRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message abacus.v2.TriggerScheduledReportRequest
 */
export type TriggerScheduledReportRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message abacus.v2.TriggerScheduledReportRequest.
 * Use `create(TriggerScheduledReportRequestSchema)` to create a new message.
 */
export const TriggerScheduledReportRequestSchema: GenMessage<TriggerScheduledReportRequest, { jsonType: TriggerScheduledReportRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 19);

/**
 * @generated from message abacus.v2.TriggerScheduledReportResponse
 */
export type TriggerScheduledReportResponse = Message<"abacus.v2.TriggerScheduledReportResponse"> & {
	/**
	 * @generated from field: abacus.v2.ScheduledReport scheduled_report = 1;
	 */
	scheduledReport?: ScheduledReport | undefined;
};

/**
 * @generated from message abacus.v2.TriggerScheduledReportResponse
 */
export type TriggerScheduledReportResponseJson = {
	/**
	 * @generated from field: abacus.v2.ScheduledReport scheduled_report = 1;
	 */
	scheduledReport?: ScheduledReportJson;
};

/**
 * Describes the message abacus.v2.TriggerScheduledReportResponse.
 * Use `create(TriggerScheduledReportResponseSchema)` to create a new message.
 */
export const TriggerScheduledReportResponseSchema: GenMessage<TriggerScheduledReportResponse, { jsonType: TriggerScheduledReportResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 20);

/**
 * @generated from message abacus.v2.DeleteScheduledReportRequest
 */
export type DeleteScheduledReportRequest = Message<"abacus.v2.DeleteScheduledReportRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message abacus.v2.DeleteScheduledReportRequest
 */
export type DeleteScheduledReportRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message abacus.v2.DeleteScheduledReportRequest.
 * Use `create(DeleteScheduledReportRequestSchema)` to create a new message.
 */
export const DeleteScheduledReportRequestSchema: GenMessage<DeleteScheduledReportRequest, { jsonType: DeleteScheduledReportRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 21);

/**
 * @generated from message abacus.v2.DeleteScheduledReportResponse
 */
export type DeleteScheduledReportResponse = Message<"abacus.v2.DeleteScheduledReportResponse"> & {};

/**
 * @generated from message abacus.v2.DeleteScheduledReportResponse
 */
export type DeleteScheduledReportResponseJson = {};

/**
 * Describes the message abacus.v2.DeleteScheduledReportResponse.
 * Use `create(DeleteScheduledReportResponseSchema)` to create a new message.
 */
export const DeleteScheduledReportResponseSchema: GenMessage<DeleteScheduledReportResponse, { jsonType: DeleteScheduledReportResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 22);

/**
 * @generated from message abacus.v2.TransferScheduledReportRequest
 */
export type TransferScheduledReportRequest = Message<"abacus.v2.TransferScheduledReportRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: common.v1.Creator creator = 2;
	 */
	creator?: Creator | undefined;
};

/**
 * @generated from message abacus.v2.TransferScheduledReportRequest
 */
export type TransferScheduledReportRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: common.v1.Creator creator = 2;
	 */
	creator?: CreatorJson;
};

/**
 * Describes the message abacus.v2.TransferScheduledReportRequest.
 * Use `create(TransferScheduledReportRequestSchema)` to create a new message.
 */
export const TransferScheduledReportRequestSchema: GenMessage<TransferScheduledReportRequest, { jsonType: TransferScheduledReportRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 23);

/**
 * @generated from message abacus.v2.TransferScheduledReportResponse
 */
export type TransferScheduledReportResponse = Message<"abacus.v2.TransferScheduledReportResponse"> & {
	/**
	 * @generated from field: abacus.v2.ScheduledReport scheduled_report = 1;
	 */
	scheduledReport?: ScheduledReport | undefined;
};

/**
 * @generated from message abacus.v2.TransferScheduledReportResponse
 */
export type TransferScheduledReportResponseJson = {
	/**
	 * @generated from field: abacus.v2.ScheduledReport scheduled_report = 1;
	 */
	scheduledReport?: ScheduledReportJson;
};

/**
 * Describes the message abacus.v2.TransferScheduledReportResponse.
 * Use `create(TransferScheduledReportResponseSchema)` to create a new message.
 */
export const TransferScheduledReportResponseSchema: GenMessage<TransferScheduledReportResponse, { jsonType: TransferScheduledReportResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 24);

/**
 * @generated from message abacus.v2.DashboardConfig
 */
export type DashboardConfig = Message<"abacus.v2.DashboardConfig"> & {
	/**
	 * @generated from field: repeated abacus.v2.ChartRequest chart_requests = 1;
	 */
	chartRequests: ChartRequest[];

	/**
	 * @generated from field: int32 total_rows = 2;
	 */
	totalRows: number;

	/**
	 * @generated from field: int32 total_columns = 3;
	 */
	totalColumns: number;

	/**
	 * @generated from field: abacus.v2.DashboardFilter dashboard_filter = 4;
	 */
	dashboardFilter?: DashboardFilter | undefined;
};

/**
 * @generated from message abacus.v2.DashboardConfig
 */
export type DashboardConfigJson = {
	/**
	 * @generated from field: repeated abacus.v2.ChartRequest chart_requests = 1;
	 */
	chartRequests?: ChartRequestJson[];

	/**
	 * @generated from field: int32 total_rows = 2;
	 */
	totalRows?: number;

	/**
	 * @generated from field: int32 total_columns = 3;
	 */
	totalColumns?: number;

	/**
	 * @generated from field: abacus.v2.DashboardFilter dashboard_filter = 4;
	 */
	dashboardFilter?: DashboardFilterJson;
};

/**
 * Describes the message abacus.v2.DashboardConfig.
 * Use `create(DashboardConfigSchema)` to create a new message.
 */
export const DashboardConfigSchema: GenMessage<DashboardConfig, { jsonType: DashboardConfigJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 25);

/**
 * @generated from message abacus.v2.Dashboard
 */
export type Dashboard = Message<"abacus.v2.Dashboard"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string suite_id = 4;
	 */
	suiteId: string;

	/**
	 * @generated from field: common.v1.Creator creator = 5;
	 */
	creator?: Creator | undefined;

	/**
	 * @generated from field: string name = 6;
	 */
	name: string;

	/**
	 * @generated from field: string description = 7;
	 */
	description: string;

	/**
	 * @generated from field: abacus.v2.DashboardConfig config = 8;
	 */
	config?: DashboardConfig | undefined;

	/**
	 * @generated from field: abacus.v2.DashboardState state = 11;
	 */
	state: DashboardState;

	/**
	 * @generated from field: bool is_default = 12;
	 */
	isDefault: boolean;

	/**
	 * @generated from field: abacus.v2.DashboardLocation location = 13;
	 */
	location: DashboardLocation;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 9;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 10;
	 */
	updatedAt?: Timestamp | undefined;
};

/**
 * @generated from message abacus.v2.Dashboard
 */
export type DashboardJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string suite_id = 4;
	 */
	suiteId?: string;

	/**
	 * @generated from field: common.v1.Creator creator = 5;
	 */
	creator?: CreatorJson;

	/**
	 * @generated from field: string name = 6;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 7;
	 */
	description?: string;

	/**
	 * @generated from field: abacus.v2.DashboardConfig config = 8;
	 */
	config?: DashboardConfigJson;

	/**
	 * @generated from field: abacus.v2.DashboardState state = 11;
	 */
	state?: DashboardStateJson;

	/**
	 * @generated from field: bool is_default = 12;
	 */
	isDefault?: boolean;

	/**
	 * @generated from field: abacus.v2.DashboardLocation location = 13;
	 */
	location?: DashboardLocationJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 9;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 10;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message abacus.v2.Dashboard.
 * Use `create(DashboardSchema)` to create a new message.
 */
export const DashboardSchema: GenMessage<Dashboard, { jsonType: DashboardJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 26);

/**
 * @generated from message abacus.v2.CreateDashboardRequest
 */
export type CreateDashboardRequest = Message<"abacus.v2.CreateDashboardRequest"> & {
	/**
	 * @generated from field: abacus.v2.Dashboard dashboard = 1;
	 */
	dashboard?: Dashboard | undefined;
};

/**
 * @generated from message abacus.v2.CreateDashboardRequest
 */
export type CreateDashboardRequestJson = {
	/**
	 * @generated from field: abacus.v2.Dashboard dashboard = 1;
	 */
	dashboard?: DashboardJson;
};

/**
 * Describes the message abacus.v2.CreateDashboardRequest.
 * Use `create(CreateDashboardRequestSchema)` to create a new message.
 */
export const CreateDashboardRequestSchema: GenMessage<CreateDashboardRequest, { jsonType: CreateDashboardRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 27);

/**
 * @generated from message abacus.v2.CreateDashboardResponse
 */
export type CreateDashboardResponse = Message<"abacus.v2.CreateDashboardResponse"> & {
	/**
	 * @generated from field: abacus.v2.Dashboard dashboard = 1;
	 */
	dashboard?: Dashboard | undefined;
};

/**
 * @generated from message abacus.v2.CreateDashboardResponse
 */
export type CreateDashboardResponseJson = {
	/**
	 * @generated from field: abacus.v2.Dashboard dashboard = 1;
	 */
	dashboard?: DashboardJson;
};

/**
 * Describes the message abacus.v2.CreateDashboardResponse.
 * Use `create(CreateDashboardResponseSchema)` to create a new message.
 */
export const CreateDashboardResponseSchema: GenMessage<CreateDashboardResponse, { jsonType: CreateDashboardResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 28);

/**
 * @generated from message abacus.v2.UpdateDashboardRequest
 */
export type UpdateDashboardRequest = Message<"abacus.v2.UpdateDashboardRequest"> & {
	/**
	 * @generated from field: abacus.v2.Dashboard dashboard = 1;
	 */
	dashboard?: Dashboard | undefined;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;
};

/**
 * @generated from message abacus.v2.UpdateDashboardRequest
 */
export type UpdateDashboardRequestJson = {
	/**
	 * @generated from field: abacus.v2.Dashboard dashboard = 1;
	 */
	dashboard?: DashboardJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message abacus.v2.UpdateDashboardRequest.
 * Use `create(UpdateDashboardRequestSchema)` to create a new message.
 */
export const UpdateDashboardRequestSchema: GenMessage<UpdateDashboardRequest, { jsonType: UpdateDashboardRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 29);

/**
 * @generated from message abacus.v2.UpdateDashboardResponse
 */
export type UpdateDashboardResponse = Message<"abacus.v2.UpdateDashboardResponse"> & {
	/**
	 * @generated from field: abacus.v2.Dashboard dashboard = 1;
	 */
	dashboard?: Dashboard | undefined;
};

/**
 * @generated from message abacus.v2.UpdateDashboardResponse
 */
export type UpdateDashboardResponseJson = {
	/**
	 * @generated from field: abacus.v2.Dashboard dashboard = 1;
	 */
	dashboard?: DashboardJson;
};

/**
 * Describes the message abacus.v2.UpdateDashboardResponse.
 * Use `create(UpdateDashboardResponseSchema)` to create a new message.
 */
export const UpdateDashboardResponseSchema: GenMessage<UpdateDashboardResponse, { jsonType: UpdateDashboardResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 30);

/**
 * @generated from message abacus.v2.ArchiveDashboardRequest
 */
export type ArchiveDashboardRequest = Message<"abacus.v2.ArchiveDashboardRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message abacus.v2.ArchiveDashboardRequest
 */
export type ArchiveDashboardRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message abacus.v2.ArchiveDashboardRequest.
 * Use `create(ArchiveDashboardRequestSchema)` to create a new message.
 */
export const ArchiveDashboardRequestSchema: GenMessage<ArchiveDashboardRequest, { jsonType: ArchiveDashboardRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 31);

/**
 * @generated from message abacus.v2.ArchiveDashboardResponse
 */
export type ArchiveDashboardResponse = Message<"abacus.v2.ArchiveDashboardResponse"> & {
	/**
	 * @generated from field: abacus.v2.Dashboard dashboard = 1;
	 */
	dashboard?: Dashboard | undefined;
};

/**
 * @generated from message abacus.v2.ArchiveDashboardResponse
 */
export type ArchiveDashboardResponseJson = {
	/**
	 * @generated from field: abacus.v2.Dashboard dashboard = 1;
	 */
	dashboard?: DashboardJson;
};

/**
 * Describes the message abacus.v2.ArchiveDashboardResponse.
 * Use `create(ArchiveDashboardResponseSchema)` to create a new message.
 */
export const ArchiveDashboardResponseSchema: GenMessage<ArchiveDashboardResponse, { jsonType: ArchiveDashboardResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 32);

/**
 * @generated from message abacus.v2.RestoreDashboardRequest
 */
export type RestoreDashboardRequest = Message<"abacus.v2.RestoreDashboardRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message abacus.v2.RestoreDashboardRequest
 */
export type RestoreDashboardRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message abacus.v2.RestoreDashboardRequest.
 * Use `create(RestoreDashboardRequestSchema)` to create a new message.
 */
export const RestoreDashboardRequestSchema: GenMessage<RestoreDashboardRequest, { jsonType: RestoreDashboardRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 33);

/**
 * @generated from message abacus.v2.RestoreDashboardResponse
 */
export type RestoreDashboardResponse = Message<"abacus.v2.RestoreDashboardResponse"> & {
	/**
	 * @generated from field: abacus.v2.Dashboard dashboard = 1;
	 */
	dashboard?: Dashboard | undefined;
};

/**
 * @generated from message abacus.v2.RestoreDashboardResponse
 */
export type RestoreDashboardResponseJson = {
	/**
	 * @generated from field: abacus.v2.Dashboard dashboard = 1;
	 */
	dashboard?: DashboardJson;
};

/**
 * Describes the message abacus.v2.RestoreDashboardResponse.
 * Use `create(RestoreDashboardResponseSchema)` to create a new message.
 */
export const RestoreDashboardResponseSchema: GenMessage<RestoreDashboardResponse, { jsonType: RestoreDashboardResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 34);

/**
 * @generated from message abacus.v2.GetDashboardRequest
 */
export type GetDashboardRequest = Message<"abacus.v2.GetDashboardRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message abacus.v2.GetDashboardRequest
 */
export type GetDashboardRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message abacus.v2.GetDashboardRequest.
 * Use `create(GetDashboardRequestSchema)` to create a new message.
 */
export const GetDashboardRequestSchema: GenMessage<GetDashboardRequest, { jsonType: GetDashboardRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 35);

/**
 * @generated from message abacus.v2.GetDashboardResponse
 */
export type GetDashboardResponse = Message<"abacus.v2.GetDashboardResponse"> & {
	/**
	 * @generated from field: abacus.v2.Dashboard dashboard = 1;
	 */
	dashboard?: Dashboard | undefined;
};

/**
 * @generated from message abacus.v2.GetDashboardResponse
 */
export type GetDashboardResponseJson = {
	/**
	 * @generated from field: abacus.v2.Dashboard dashboard = 1;
	 */
	dashboard?: DashboardJson;
};

/**
 * Describes the message abacus.v2.GetDashboardResponse.
 * Use `create(GetDashboardResponseSchema)` to create a new message.
 */
export const GetDashboardResponseSchema: GenMessage<GetDashboardResponse, { jsonType: GetDashboardResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 36);

/**
 * @generated from message abacus.v2.GetDashboardsRequest
 */
export type GetDashboardsRequest = Message<"abacus.v2.GetDashboardsRequest"> & {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids: string[];
};

/**
 * @generated from message abacus.v2.GetDashboardsRequest
 */
export type GetDashboardsRequestJson = {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids?: string[];
};

/**
 * Describes the message abacus.v2.GetDashboardsRequest.
 * Use `create(GetDashboardsRequestSchema)` to create a new message.
 */
export const GetDashboardsRequestSchema: GenMessage<GetDashboardsRequest, { jsonType: GetDashboardsRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 37);

/**
 * @generated from message abacus.v2.GetDashboardsResponse
 */
export type GetDashboardsResponse = Message<"abacus.v2.GetDashboardsResponse"> & {
	/**
	 * @generated from field: repeated abacus.v2.Dashboard dashboards = 1;
	 */
	dashboards: Dashboard[];
};

/**
 * @generated from message abacus.v2.GetDashboardsResponse
 */
export type GetDashboardsResponseJson = {
	/**
	 * @generated from field: repeated abacus.v2.Dashboard dashboards = 1;
	 */
	dashboards?: DashboardJson[];
};

/**
 * Describes the message abacus.v2.GetDashboardsResponse.
 * Use `create(GetDashboardsResponseSchema)` to create a new message.
 */
export const GetDashboardsResponseSchema: GenMessage<GetDashboardsResponse, { jsonType: GetDashboardsResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 38);

/**
 * @generated from message abacus.v2.ListDashboardsRequest
 */
export type ListDashboardsRequest = Message<"abacus.v2.ListDashboardsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string suite_id = 3;
	 */
	suiteId: string;

	/**
	 * @generated from field: string name = 4;
	 */
	name: string;

	/**
	 * @generated from field: string user_id = 5;
	 */
	userId: string;

	/**
	 * @generated from field: string creator_email = 6;
	 */
	creatorEmail: string;

	/**
	 * @generated from field: repeated string user_ids = 11;
	 */
	userIds: string[];

	/**
	 * @generated from field: repeated string creator_emails = 12;
	 */
	creatorEmails: string[];

	/**
	 * @generated from field: repeated string workspace_ids = 13;
	 */
	workspaceIds: string[];

	/**
	 * @generated from field: abacus.v2.DashboardLocation location = 10;
	 */
	location: DashboardLocation;

	/**
	 * @generated from field: repeated abacus.v2.DashboardLocation locations = 14;
	 */
	locations: DashboardLocation[];

	/**
	 * @generated from field: repeated abacus.v2.DashboardState states = 8;
	 */
	states: DashboardState[];

	/**
	 * @generated from field: optional bool is_default = 9;
	 */
	isDefault?: boolean | undefined;

	/**
	 * @generated from field: optional common.v1.PaginationArguments pagination = 7;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * @generated from message abacus.v2.ListDashboardsRequest
 */
export type ListDashboardsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string suite_id = 3;
	 */
	suiteId?: string;

	/**
	 * @generated from field: string name = 4;
	 */
	name?: string;

	/**
	 * @generated from field: string user_id = 5;
	 */
	userId?: string;

	/**
	 * @generated from field: string creator_email = 6;
	 */
	creatorEmail?: string;

	/**
	 * @generated from field: repeated string user_ids = 11;
	 */
	userIds?: string[];

	/**
	 * @generated from field: repeated string creator_emails = 12;
	 */
	creatorEmails?: string[];

	/**
	 * @generated from field: repeated string workspace_ids = 13;
	 */
	workspaceIds?: string[];

	/**
	 * @generated from field: abacus.v2.DashboardLocation location = 10;
	 */
	location?: DashboardLocationJson;

	/**
	 * @generated from field: repeated abacus.v2.DashboardLocation locations = 14;
	 */
	locations?: DashboardLocationJson[];

	/**
	 * @generated from field: repeated abacus.v2.DashboardState states = 8;
	 */
	states?: DashboardStateJson[];

	/**
	 * @generated from field: optional bool is_default = 9;
	 */
	isDefault?: boolean;

	/**
	 * @generated from field: optional common.v1.PaginationArguments pagination = 7;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message abacus.v2.ListDashboardsRequest.
 * Use `create(ListDashboardsRequestSchema)` to create a new message.
 */
export const ListDashboardsRequestSchema: GenMessage<ListDashboardsRequest, { jsonType: ListDashboardsRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 39);

/**
 * @generated from message abacus.v2.ListDashboardsResponse
 */
export type ListDashboardsResponse = Message<"abacus.v2.ListDashboardsResponse"> & {
	/**
	 * @generated from field: repeated abacus.v2.Dashboard dashboards = 1;
	 */
	dashboards: Dashboard[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message abacus.v2.ListDashboardsResponse
 */
export type ListDashboardsResponseJson = {
	/**
	 * @generated from field: repeated abacus.v2.Dashboard dashboards = 1;
	 */
	dashboards?: DashboardJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message abacus.v2.ListDashboardsResponse.
 * Use `create(ListDashboardsResponseSchema)` to create a new message.
 */
export const ListDashboardsResponseSchema: GenMessage<ListDashboardsResponse, { jsonType: ListDashboardsResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 40);

/**
 * @generated from message abacus.v2.DeleteDashboardRequest
 */
export type DeleteDashboardRequest = Message<"abacus.v2.DeleteDashboardRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message abacus.v2.DeleteDashboardRequest
 */
export type DeleteDashboardRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message abacus.v2.DeleteDashboardRequest.
 * Use `create(DeleteDashboardRequestSchema)` to create a new message.
 */
export const DeleteDashboardRequestSchema: GenMessage<DeleteDashboardRequest, { jsonType: DeleteDashboardRequestJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 41);

/**
 * @generated from message abacus.v2.DeleteDashboardResponse
 */
export type DeleteDashboardResponse = Message<"abacus.v2.DeleteDashboardResponse"> & {};

/**
 * @generated from message abacus.v2.DeleteDashboardResponse
 */
export type DeleteDashboardResponseJson = {};

/**
 * Describes the message abacus.v2.DeleteDashboardResponse.
 * Use `create(DeleteDashboardResponseSchema)` to create a new message.
 */
export const DeleteDashboardResponseSchema: GenMessage<DeleteDashboardResponse, { jsonType: DeleteDashboardResponseJson }> = /*@__PURE__*/ messageDesc(file_abacus_v2_reports, 42);

/**
 * @generated from enum abacus.v2.ScheduledReportState
 */
export enum ScheduledReportState {
	/**
	 * @generated from enum value: SCHEDULED_REPORT_STATE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: SCHEDULED_REPORT_STATE_ACTIVE = 1;
	 */
	ACTIVE = 1,

	/**
	 * @generated from enum value: SCHEDULED_REPORT_STATE_INACTIVE = 2;
	 */
	INACTIVE = 2,

	/**
	 * @generated from enum value: SCHEDULED_REPORT_STATE_ORPHAN = 3;
	 */
	ORPHAN = 3,
}

/**
 * @generated from enum abacus.v2.ScheduledReportState
 */
export type ScheduledReportStateJson = "SCHEDULED_REPORT_STATE_UNSPECIFIED" | "SCHEDULED_REPORT_STATE_ACTIVE" | "SCHEDULED_REPORT_STATE_INACTIVE" | "SCHEDULED_REPORT_STATE_ORPHAN";

/**
 * Describes the enum abacus.v2.ScheduledReportState.
 */
export const ScheduledReportStateSchema: GenEnum<ScheduledReportState, ScheduledReportStateJson> = /*@__PURE__*/ enumDesc(file_abacus_v2_reports, 0);

/**
 * @generated from enum abacus.v2.ScheduledReportType
 */
export enum ScheduledReportType {
	/**
	 * @generated from enum value: SCHEDULED_REPORT_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: SCHEDULED_REPORT_TYPE_ORG_DASHBOARD = 1;
	 */
	ORG_DASHBOARD = 1,

	/**
	 * @generated from enum value: SCHEDULED_REPORT_TYPE_WORKSPACE_DASHBOARD = 2;
	 */
	WORKSPACE_DASHBOARD = 2,

	/**
	 * @generated from enum value: SCHEDULED_REPORT_TYPE_FLOW_DASHBOARD = 3;
	 */
	FLOW_DASHBOARD = 3,
}

/**
 * @generated from enum abacus.v2.ScheduledReportType
 */
export type ScheduledReportTypeJson = "SCHEDULED_REPORT_TYPE_UNSPECIFIED" | "SCHEDULED_REPORT_TYPE_ORG_DASHBOARD" | "SCHEDULED_REPORT_TYPE_WORKSPACE_DASHBOARD" | "SCHEDULED_REPORT_TYPE_FLOW_DASHBOARD";

/**
 * Describes the enum abacus.v2.ScheduledReportType.
 */
export const ScheduledReportTypeSchema: GenEnum<ScheduledReportType, ScheduledReportTypeJson> = /*@__PURE__*/ enumDesc(file_abacus_v2_reports, 1);

/**
 * @generated from enum abacus.v2.ScheduledReportFrequency
 */
export enum ScheduledReportFrequency {
	/**
	 * @generated from enum value: SCHEDULED_REPORT_FREQUENCY_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: SCHEDULED_REPORT_FREQUENCY_MINUTES = 1;
	 */
	MINUTES = 1,

	/**
	 * @generated from enum value: SCHEDULED_REPORT_FREQUENCY_HOURLY = 2;
	 */
	HOURLY = 2,

	/**
	 * @generated from enum value: SCHEDULED_REPORT_FREQUENCY_DAILY = 3;
	 */
	DAILY = 3,

	/**
	 * @generated from enum value: SCHEDULED_REPORT_FREQUENCY_WEEKLY = 4;
	 */
	WEEKLY = 4,

	/**
	 * @generated from enum value: SCHEDULED_REPORT_FREQUENCY_MONTHLY = 5;
	 */
	MONTHLY = 5,

	/**
	 * @generated from enum value: SCHEDULED_REPORT_FREQUENCY_CUSTOM = 6;
	 */
	CUSTOM = 6,

	/**
	 * @generated from enum value: SCHEDULED_REPORT_FREQUENCY_ONCE = 7;
	 */
	ONCE = 7,
}

/**
 * @generated from enum abacus.v2.ScheduledReportFrequency
 */
export type ScheduledReportFrequencyJson = "SCHEDULED_REPORT_FREQUENCY_UNSPECIFIED" | "SCHEDULED_REPORT_FREQUENCY_MINUTES" | "SCHEDULED_REPORT_FREQUENCY_HOURLY" | "SCHEDULED_REPORT_FREQUENCY_DAILY" | "SCHEDULED_REPORT_FREQUENCY_WEEKLY" | "SCHEDULED_REPORT_FREQUENCY_MONTHLY" | "SCHEDULED_REPORT_FREQUENCY_CUSTOM" | "SCHEDULED_REPORT_FREQUENCY_ONCE";

/**
 * Describes the enum abacus.v2.ScheduledReportFrequency.
 */
export const ScheduledReportFrequencySchema: GenEnum<ScheduledReportFrequency, ScheduledReportFrequencyJson> = /*@__PURE__*/ enumDesc(file_abacus_v2_reports, 2);

/**
 * @generated from enum abacus.v2.DashboardState
 */
export enum DashboardState {
	/**
	 * @generated from enum value: DASHBOARD_STATE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: DASHBOARD_STATE_ACTIVE = 1;
	 */
	ACTIVE = 1,

	/**
	 * @generated from enum value: DASHBOARD_STATE_ARCHIVED = 2;
	 */
	ARCHIVED = 2,
}

/**
 * @generated from enum abacus.v2.DashboardState
 */
export type DashboardStateJson = "DASHBOARD_STATE_UNSPECIFIED" | "DASHBOARD_STATE_ACTIVE" | "DASHBOARD_STATE_ARCHIVED";

/**
 * Describes the enum abacus.v2.DashboardState.
 */
export const DashboardStateSchema: GenEnum<DashboardState, DashboardStateJson> = /*@__PURE__*/ enumDesc(file_abacus_v2_reports, 3);

/**
 * @generated from enum abacus.v2.DashboardLocation
 */
export enum DashboardLocation {
	/**
	 * @generated from enum value: DASHBOARD_LOCATION_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: DASHBOARD_LOCATION_ORG = 1;
	 */
	ORG = 1,

	/**
	 * @generated from enum value: DASHBOARD_LOCATION_WORKSPACE = 2;
	 */
	WORKSPACE = 2,

	/**
	 * @generated from enum value: DASHBOARD_LOCATION_FLOW = 3;
	 */
	FLOW = 3,
}

/**
 * @generated from enum abacus.v2.DashboardLocation
 */
export type DashboardLocationJson = "DASHBOARD_LOCATION_UNSPECIFIED" | "DASHBOARD_LOCATION_ORG" | "DASHBOARD_LOCATION_WORKSPACE" | "DASHBOARD_LOCATION_FLOW";

/**
 * Describes the enum abacus.v2.DashboardLocation.
 */
export const DashboardLocationSchema: GenEnum<DashboardLocation, DashboardLocationJson> = /*@__PURE__*/ enumDesc(file_abacus_v2_reports, 4);

/**
 * @generated from service abacus.v2.ReportsService
 */
export const ReportsService: GenService<{
	/**
	 * @generated from rpc abacus.v2.ReportsService.ExecuteReport
	 */
	executeReport: {
		methodKind: "unary";
		input: typeof ExecuteReportRequestSchema;
		output: typeof ExecuteReportResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.ReportsService.CreateScheduledReport
	 */
	createScheduledReport: {
		methodKind: "unary";
		input: typeof CreateScheduledReportRequestSchema;
		output: typeof CreateScheduledReportResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.ReportsService.UpdateScheduledReport
	 */
	updateScheduledReport: {
		methodKind: "unary";
		input: typeof UpdateScheduledReportRequestSchema;
		output: typeof UpdateScheduledReportResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.ReportsService.GetScheduledReport
	 */
	getScheduledReport: {
		methodKind: "unary";
		input: typeof GetScheduledReportRequestSchema;
		output: typeof GetScheduledReportResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.ReportsService.ListScheduledReports
	 */
	listScheduledReports: {
		methodKind: "unary";
		input: typeof ListScheduledReportsRequestSchema;
		output: typeof ListScheduledReportsResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.ReportsService.ToggleScheduledReport
	 */
	toggleScheduledReport: {
		methodKind: "unary";
		input: typeof ToggleScheduledReportRequestSchema;
		output: typeof ToggleScheduledReportResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.ReportsService.TriggerScheduledReport
	 */
	triggerScheduledReport: {
		methodKind: "unary";
		input: typeof TriggerScheduledReportRequestSchema;
		output: typeof TriggerScheduledReportResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.ReportsService.DeleteScheduledReport
	 */
	deleteScheduledReport: {
		methodKind: "unary";
		input: typeof DeleteScheduledReportRequestSchema;
		output: typeof DeleteScheduledReportResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.ReportsService.TransferScheduledReport
	 */
	transferScheduledReport: {
		methodKind: "unary";
		input: typeof TransferScheduledReportRequestSchema;
		output: typeof TransferScheduledReportResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.ReportsService.CreateDashboard
	 */
	createDashboard: {
		methodKind: "unary";
		input: typeof CreateDashboardRequestSchema;
		output: typeof CreateDashboardResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.ReportsService.UpdateDashboard
	 */
	updateDashboard: {
		methodKind: "unary";
		input: typeof UpdateDashboardRequestSchema;
		output: typeof UpdateDashboardResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.ReportsService.ArchiveDashboard
	 */
	archiveDashboard: {
		methodKind: "unary";
		input: typeof ArchiveDashboardRequestSchema;
		output: typeof ArchiveDashboardResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.ReportsService.RestoreDashboard
	 */
	restoreDashboard: {
		methodKind: "unary";
		input: typeof RestoreDashboardRequestSchema;
		output: typeof RestoreDashboardResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.ReportsService.GetDashboard
	 */
	getDashboard: {
		methodKind: "unary";
		input: typeof GetDashboardRequestSchema;
		output: typeof GetDashboardResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.ReportsService.GetDashboards
	 */
	getDashboards: {
		methodKind: "unary";
		input: typeof GetDashboardsRequestSchema;
		output: typeof GetDashboardsResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.ReportsService.ListDashboards
	 */
	listDashboards: {
		methodKind: "unary";
		input: typeof ListDashboardsRequestSchema;
		output: typeof ListDashboardsResponseSchema;
	};
	/**
	 * @generated from rpc abacus.v2.ReportsService.DeleteDashboard
	 */
	deleteDashboard: {
		methodKind: "unary";
		input: typeof DeleteDashboardRequestSchema;
		output: typeof DeleteDashboardResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_abacus_v2_reports, 0);
